// tslint:disable
export var VirmedicaJobType;
(function (VirmedicaJobType) {
    // Job for Virmedica callback events
    VirmedicaJobType[VirmedicaJobType["VrmCallback"] = 1] = "VrmCallback";
})(VirmedicaJobType || (VirmedicaJobType = {}));
VirmedicaJobType['VRMCALLBACK'] = 1;
//# sourceMappingURL=VirmedicaJobType.js.map